<div class="action-container desc">
    Realiza tu pago utilizando tu proveedor de servicio de pagos de confianza
  </div>

  <app-card-image-list></app-card-image-list>

  <div class="line-decorator"></div>

<!--  <div class="text-center">-->
<!--    <div-->
<!--      class="card-customer-container"-->
<!--      *ngIf="flashPaymentService.controller.tokenCards.length !== 0"-->
<!--    >-->
<!--      <div class="text-container">-->
<!--        <strong>Mis métodos de pago almacenados</strong>-->
<!--      </div>-->

<!--      <div class="light-text">Utiliza tus métodos de pago almacenados</div>-->

<!--      <div class="text-container">-->
<!--        <strong>Mis Tarjetas</strong>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

  <div>
<!--    <app-card-carousel [canShowArrows]="cantShowArrows"></app-card-carousel>-->

<!--    <div class="line-decorator" *ngIf="flashPaymentService.controller.tokenCards.length > 0"></div>-->

    <div class="action-container">
      <button *ngIf="flashPaymentService.controller.isPlaceToPay" class="btn btn-danger action-btn" (click)="flashPaymentService.buildAuthorizationRequest()">
        Pagar {{ flashPaymentService.controller.operationAmount | currency }}
      </button>
    </div>
  </div>
